<div class="reports main-div-with-gray-bkg">
  <!-- class="height-separater" -->
  <div class="p-3 pb-0 row">
    <div class="col">
      @if (pagename && ReportName) {
      <h6 class="page-header text-capitalize">{{ pagename + ' > ' + ReportName }}</h6>
      }
    </div>
  </div>
  <div class="p-3 pt-0 row">
    @if (appliedfilter && appliedfilter.length > 0) {
    <div style="display: none;" class="col">
      <strong>Applied Filters:</strong>
      <span>
        @for (filter of appliedfilter; track filter; let i = $index) { @for (key of objectKeys(filter); track key) {
        <span>
          <span class="badge bg-secondary me-1">{{ key }}</span
          >: {{ checkjson(filter[key]) }}@if (i < appliedfilter.length - 1) {
          <span>, </span>
          }
        </span>
        } }
      </span>
    </div>
    }
  </div>
  <div class="p-3 pt-0 row">
    <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 p-0">
      <div class="card-table-gap p-0">
        <div class="col-xs-12 col-sm-12 col-lg-12 col-xl-12 col-xs-12 card-structure">
          <div class="report" id="reportContainer"></div>
        </div>
      </div>
    </div>
  </div>
</div>
